import React from 'react';
import { Mail, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-blue-900 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8">お問い合わせ</h2>
        <p className="text-lg text-blue-100 mb-12">
          コンテストに関するご質問やエントリーについては、<br className="hidden md:inline"/>下記までお気軽にお問い合わせください。申込書は募集要項の欄にございます。</p>

        <div className="bg-white/10 backdrop-blur-md rounded-xl p-8 md:p-12 border border-white/20">
          <h3 className="text-xl font-bold mb-6">大学対抗ピアノ演奏チームコンテスト実行委員会</h3>
          
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-8">
            <a href="mailto:info@ryo-totsuka.jp" className="flex items-center group">
              <div className="bg-white text-blue-900 p-3 rounded-full mr-4 group-hover:scale-110 transition-transform">
                <Mail size={24} />
              </div>
              <span className="text-xl font-medium hover:underline">info@ryo-totsuka.jp</span>
            </a>
            
            <a href="tel:0333217277" className="flex items-center group">
              <div className="bg-white text-blue-900 p-3 rounded-full mr-4 group-hover:scale-110 transition-transform">
                <Phone size={24} />
              </div>
              <span className="text-xl font-medium hover:underline">03-3321-7727</span>
            </a>
          </div>

          <div className="border-t border-white/20 pt-8 mt-8">
            <p className="text-sm text-blue-200 mb-2">主催</p>
            <p className="text-lg font-semibold mb-4">大学対抗ピアノ演奏チームコンテスト実行委員会</p>
            
            <p className="text-sm text-blue-200 mb-2">マネージメント</p>
            <p className="text-lg font-semibold">一般社団法人 ユーロピアノ・マネジメント</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
